import Reveal from "@/components/base/Reveal";
import { relatedTopics } from "@/mocks/home";

export default function RelatedTopics() {
  return (
    <section id="related" className="bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <Reveal>
          <div className="max-w-2xl">
            <p className="font-label text-xs font-semibold uppercase tracking-[0.25em] text-primary-600">
              Related Themes
            </p>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              同类题材的字幕与配音选择思路
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              选择字幕还是配音，往往与题材特点有关。以下为常见题材的一般性说明，可作为判断参考。
            </p>
          </div>
        </Reveal>

        <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {relatedTopics.map((topic, index) => (
            <Reveal key={topic.title} delay={index * 70}>
              <article className="flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-5">
                <h3 className="font-heading text-base font-bold text-foreground-950">{topic.title}</h3>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-600">{topic.desc}</p>
                <div className="mt-4 flex flex-wrap gap-1.5">
                  {topic.tags.map((tag) => (
                    <span
                      key={tag}
                      className="rounded-full bg-accent-100 px-2.5 py-1 font-label text-xs text-accent-900"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal delay={140}>
          <p className="mt-8 flex items-start gap-3 rounded-lg border border-background-300 bg-secondary-100/70 px-5 py-4 text-xs leading-relaxed text-foreground-600">
            <i className="ri-information-line mt-0.5 text-secondary-700" aria-hidden="true"></i>
            以上为题材层面的通用说明，用于帮助理解字幕与配音的取舍逻辑，不代表对具体作品情节的描述。
          </p>
        </Reveal>
      </div>
    </section>
  );
}